var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.845947 0.537109)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8859 12.7985C23.8859 11.983 23.8128 11.199 23.6769 10.4462H12.8459V14.8946H19.035C18.7684 16.3321 17.9582 17.5501 16.7403 18.3655V21.251H20.4569C22.6314 19.249 23.8859 16.3008 23.8859 12.7985Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8458 24.0369C15.9508 24.0369 18.554 23.0072 20.4568 21.2508L16.7402 18.3653C15.7104 19.0553 14.3931 19.4631 12.8458 19.4631C9.85062 19.4631 7.31539 17.4401 6.41108 14.7219H2.56903V17.7015C4.4613 21.4599 8.35039 24.0369 12.8458 24.0369Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41117 14.7222C6.18117 14.0322 6.05049 13.2951 6.05049 12.5372C6.05049 11.7792 6.18117 11.0422 6.41117 10.3522V7.37262H2.56913C1.79027 8.92512 1.34595 10.6815 1.34595 12.5372C1.34595 14.3928 1.79027 16.1492 2.56913 17.7017L6.41117 14.7222Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8458 5.61097C14.5343 5.61097 16.0502 6.1912 17.242 7.33075L20.5404 4.03234C18.5488 2.17665 15.9456 1.03711 12.8458 1.03711C8.3504 1.03711 4.4613 3.61415 2.56903 7.37256L6.41108 10.3521C7.31539 7.63393 9.85062 5.61097 12.8458 5.61097Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.48e87ddf1067987bc1300f6785cf39a3.svg";
export { ForwardRef as ReactComponent };